<template>
  <div>
    <list-vue
      v-bind:busqueda="busqueda"
      v-bind:busquedaTraduccion="busquedaTraduccion"
      v-bind:busquedaMedidas="busquedaMedidas"
      v-bind:opciones="opciones"
      v-bind:moduloTitulo="moduloTitulo"
      v-bind:pantallaTitulo="pantallaTitulo"
      v-bind:rutaConsulta="rutaConsulta"
      v-bind:buttonsPage="buttonsPage"
      v-bind:busquedaCampos="busquedaCampos"
    ></list-vue>
  </div>


</template>
    <script type="text/javascript">
import { mapState } from "vuex";
import { mapMutations } from "vuex";
export default {
  data() {
    return {
      //Definimos los nombres generales
      moduloTitulo: this.$root.trans("Tabla de Accesos por Tipo de Registro"),
      reporte: false,
      pantallaTitulo: this.$root.trans("Resultado"),
      rutaConsulta: this.$route.fullPath,
      buttonsPage: [
        {
          type: "button",
          class: "btn btn-xs btn-info pull-right",
          route: "AuthorsCreate",
          text: '<i class="fa fa-plus">',
          external: "../../../../../editaacceso_tiponc.php?filtroTipoNC=RE",
        },
      ],
      //Definimos los campos de busqueda, sus nombres e incluso tamaño
      busqueda: {
        codigo: "",
        tipo_acceso: "",
        tipo_nc_codi: "",
      },
      busquedaTraduccion: {
        usuario_codigo: this.$root.trans("Codigo"),
        tipo_acceso: this.$root.trans("Tipo de Acceso"),
        tipo_nc_codi: this.$root.trans("Tipo"),
      },
      busquedaCampos: {
        usuario_codigo: {
          type: "select",
          options: [],
        },
        tipo_acceso: {
          type: "select",
          options: [
            { label: "Usuario", code: "U" },
            { label: "Responsable", code: "R" },
            { label: "Observador", code: "O" },
          ],
        },
        tipo_nc_codi: {
          type: "select",
          options: [],
        },
      },
      busquedaMedidas: {
        usuario_codigo: "30%",
        tipo_acceso: "20%",
        tipo_nc_codi: "30%",
      },
      //definimos las opciones con enlace simple para ello usamos el nombre de la ruta y en caso de eliminar usamos la ruta
      opciones: [
        // {
        //   class: "btn btn-sm btn-warning",
        //   icon: "fas fa-edit",
        //   routerName: "TiposRegistroEdit",
        //   param: "codigo",
        //   eliminar: false,
        //   nombre: "Editar",
        // },
        // {
        //     class:'btn btn-sm btn-danger',
        //     icon:'fa fa-trash-alt',
        //     routerName:'/backend/authors/delete/',
        //     param:'id',
        //     eliminar:true,
        //     nombre:'Eliminar'
        // }
      ],
    };
  },
  computed: {
    ...mapState(["request"]),
  },
  methods: {
    ...mapMutations({ requestSet: "request" }),
  },
  mounted() {
    this.requestSet(this.$route.query);
  },
  created() {
    this.requestSet(this.$route.query);

    const data = {
      selects: {
        User: {},
        TipoNC: { categoria_nc: "RE", estado: "all" },
      },
    };
    this.$root
      .Consulta(
        this.$root.UrlBase("selects/init"),
        data,
        "post",
        false,
        false,
        false,
        "",
        false
      )
      .then((response) => {
        this.busquedaCampos.tipo_nc_codi.options = response.TipoNC;
        this.busquedaCampos.usuario_codigo.options = response.User;
      });
  },
};
</script>
